import { t } from "i18next";
import Image from "next/image";
import type { FC } from "react";

import { Button } from "../../atoms/Button";
import { useWalletInfo } from "contexts/WalletInfoContext";
import { useParticipateInGovernance } from "hooks/governance/useParticipateInGovernance";
import Images from "styles/image-library";

export interface StakeMndeBodyProps {
  closeSettingsPopup: () => void;
  runStakeMnde: () => void;
}

export const StakeMndeBody: FC<StakeMndeBodyProps> = ({
  closeSettingsPopup,
  runStakeMnde,
}) => {
  const { walletAddress } = useWalletInfo();
  const { totalAvailableMndeAmount } = useParticipateInGovernance();

  return (
    <div className="flex flex-col mt-8-px">
      <Image
        src={Images.icons_governance_icon}
        alt="Directed to validator asset icon"
        width={64}
        height={64}
        className="self-center"
      />
      <p className="title-h2 text-center mt-24-px mb-10-px">
        {t("governance.participate")}
      </p>
      <p className="mb-4 text-secondary-text text-center body-md-regular">
        {t("governance.stake_your_mnde")}
      </p>
      {walletAddress && totalAvailableMndeAmount === 0 && (
        <Button
          variant="primary"
          label={t("governance.swap_to_mnde")}
          className="w-full mt-4 text-lg py-14-px mb-16-px"
          onClick={() => {
            window.open("https://jup.ag/swap/SOL-MNDE", "_blank", "noreferrer");
            closeSettingsPopup();
          }}
          leftIcon={
            <Image
              src={Images.icons_stake_arrow}
              width="20"
              height="20"
              alt="external"
            />
          }
        />
      )}
      {walletAddress && totalAvailableMndeAmount > 0 && (
        <Button
          variant="primary"
          label={t("governance.stake_mnde")}
          className="w-full mt-4 text-lg py-14-px mb-16-px"
          onClick={() => {
            runStakeMnde();
            closeSettingsPopup();
          }}
          leftIcon={
            <Image
              src={Images.icons_stake_arrow}
              width="20"
              height="20"
              alt="external"
            />
          }
        />
      )}
    </div>
  );
};
